import React, { useCallback } from "react";
import { useCustomPromo } from "components/CustomPromo/hooks";
import CustomPromoBanner from "components/CustomPromo/CustomPromoBanner/CustomPromoBanner";
import ClientOnly from "components/ClientOnly";
import MaybeCustomPromoModal from "components/CustomPromo/CustomPromoModal/MaybeCustomPromoModal";
import { msg, t } from "@lingui/core/macro";
import { LanguageCode } from "src/utils/localization/languages/types";
import {
  BlockContentValue,
  PartialSanityImageType
} from "@silversea-ssc/ui-components-react";
import { dateFromOptionalDate } from "src/utils/date";

type Props = {
  languageCode: LanguageCode;
  content: BlockContentValue | undefined;
  promoConfigurationCode: string | undefined;
  backgroundImage: PartialSanityImageType | undefined;
  modalTitle: BlockContentValue;
  modalContent: BlockContentValue;
};

const CustomPromo: React.FC<Props> = ({
  content,
  promoConfigurationCode,
  languageCode,
  backgroundImage,
  modalTitle,
  modalContent
}) => {
  const { promoState, updatePromoState, remotePromo, promoIsValid } =
    useCustomPromo();

  const handleModalClose = useCallback(() => {
    updatePromoState({ showCustomPromoModal: false });
  }, [updatePromoState]);

  const handleBannerClick = useCallback(() => {
    updatePromoState({ showCustomPromoModal: true });
  }, [updatePromoState]);

  const maybePromoExpirationDate = remotePromo.data
    ? dateFromOptionalDate(remotePromo.data.toDate)
    : undefined;

  return (
    <>
      <ClientOnly>
        <CustomPromoBanner
          isVisible={promoIsValid}
          onClick={handleBannerClick}
          content={content}
          promoConfigurationCode={promoConfigurationCode}
        />

        <MaybeCustomPromoModal
          title={t(msg`YOUR EXCLUSIVE BENEFIT`)}
          isPromoValid={promoIsValid}
          onRequestClose={handleModalClose}
          isVisible={promoState.showCustomPromoModal}
          languageCode={languageCode}
          backgroundImage={backgroundImage}
          promoExpirationDate={maybePromoExpirationDate}
          modalTitle={modalTitle}
          modalContent={modalContent}
          promoConfigurationCode={promoConfigurationCode}
        />
      </ClientOnly>
    </>
  );
};

export default CustomPromo;
